import script from "./CIOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./CIOverview.vue?vue&type=script&setup=true&lang=js"

import "./CIOverview.vue?vue&type=style&index=0&id=1a913a77&scoped=true&lang=postcss"

import exportComponent from "/builds/atlatl-software/atlatl-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a913a77"]])

export default __exports__